import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import CountUp from 'react-countup';
import { usePrevious } from 'react-use';
import styles from './percentageBar.module.scss';
export const PercentageBar = ({ value, label, labelWidth, theme = [colors.purple['700'], colors.neutral['200']], showFullBar = false, showDifference = false, }) => {
    const percentage = Math.min(value, 100);
    const [animationValues, setAnimationValues] = useState([
        null,
        null,
    ]);
    const prevAnimationValues = usePrevious(animationValues);
    useEffect(() => {
        setAnimationValues([
            percentage,
            ...(showFullBar ? [100 - percentage] : []),
        ]);
    }, [percentage, showFullBar]);
    const animationDuration = 1.5;
    const sections = useMemo(() => animationValues.map((num, index) => {
        var _a;
        const showText = (percentage && index === 0) || showDifference;
        const isLow = num !== null && num < 20;
        const sectionClassName = classnames(styles.section, {
            [styles.sectionHidden]: showFullBar && num === 0,
            [styles.sectionInheritRadius]: !showFullBar,
        });
        const valueClassName = classnames(styles.section, {
            [styles.valueOutside]: isLow,
        });
        return (_jsx(FlexBox, Object.assign({ justifyContent: "flex-end", alignItems: "center", padding: "0 100", background: theme[index], color: "neutral.000", className: sectionClassName, style: {
                flexBasis: `${num !== null && num !== void 0 ? num : 0}%`,
                transition: `flex-basis ${animationDuration}s ease-out`,
            } }, { children: showText && (_jsx(Text.Paragraph, Object.assign({ className: valueClassName, variant: "4", color: index === 0 && !isLow
                    ? colors.neutral['000']
                    : colors.neutral['900'] }, { children: _jsx(CountUp, Object.assign({ start: (_a = prevAnimationValues === null || prevAnimationValues === void 0 ? void 0 : prevAnimationValues[index]) !== null && _a !== void 0 ? _a : 0, end: num !== null && num !== void 0 ? num : 0, duration: animationDuration, delay: 0, suffix: '%' }, { children: ({ countUpRef }) => _jsx("span", { ref: countUpRef }) })) }))) }), index));
    }), [
        percentage,
        theme,
        showDifference,
        showFullBar,
        animationValues,
        prevAnimationValues,
    ]);
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200" }, { children: [label && (_jsx(Box, Object.assign({ minWidth: labelWidth ? `${labelWidth}px` : 'auto' }, { children: _jsx(Text.Paragraph, Object.assign({ variant: "4" }, { children: label })) }))), _jsx(FlexBox, Object.assign({ flex: "1", className: styles.bar, height: "20px", borderRadius: "50" }, { children: sections }))] })));
};
